<template>
    <v-layout row justify-center>
        <v-dialog v-model="dialog" persistent max-width="290">
            <v-card>

                    <v-alert
                            :value="true"
                            type="error"
                            class="mx-0 my-0"
                    >
                        {{title}}
                    </v-alert>

                <v-card-text>
                    <ul>
                        <li v-for="error in errorMessages">
                            {{error}}
                        </li>
                    </ul>

                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="green darken-1" flat @click="$emit('hide')">OK</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-layout>
</template>

<script>
    export default {
        name: "ValidationErrorModal",
        props :{
            dialog: {
                type : Boolean,
                default : false,
            },
            errorMessages : {},
            title : {
                type : String,
                default : 'Please Fill Up the following:',
            },
        },
        data () {
            return {

            }
        }
    }
</script>

<style scoped>

</style>